module.exports = __webpack_public_path__ + "static/empaques-15ab62d99ca21bbacfd9e00e4f218db4.png";